import { Controller } from "@hotwired/stimulus"

// Click-to-load YouTube embed for Wire stories. Renders as a cached thumbnail
// + play button until the reader opts in, then swaps in the privacy-enhanced
// iframe — so no third-party requests happen for readers who never press play.
export default class extends Controller {
  static values = { videoId: String, title: String }

  play() {
    if (!/^[A-Za-z0-9_-]{6,20}$/.test(this.videoIdValue)) return

    const iframe = document.createElement("iframe")
    iframe.src = `https://www.youtube-nocookie.com/embed/${this.videoIdValue}?autoplay=1`
    iframe.title = this.titleValue || "Video"
    iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture")
    iframe.setAttribute("allowfullscreen", "allowfullscreen")
    iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin")
    iframe.className = "wire-video-frame"
    this.element.replaceChildren(iframe)
    this.element.classList.add("wire-video--playing")
  }
}
